module.exports = __webpack_public_path__ + "img/w3_olja_dark.fe49f751.png";